<template>
  <div id="List">
    <div class="top">
      <p class="title">
        {{checkname}}荣誉榜
      </p>
      <div class="threeimg">
        <div>
          <img v-if="datathree[1]" :src="datathree[1].avatar" />
          <img v-else src="@/assets/images/activity/head.png" />
          <img src="@/assets/images/activity/top2.png" />
        </div>
        <div>
          <img v-if="datathree[0]" :src="datathree[0].avatar" />
          <img v-else src="@/assets/images/activity/head.png" />
          <img src="@/assets/images/activity/top1.png" />
        </div>
        <div>
          <img v-if="datathree[2]" :src="datathree[2].avatar" />
          <img v-else src="@/assets/images/activity/head.png" />
          <img src="@/assets/images/activity/top3.png" />
        </div>
      </div>
      <p class="first" v-if="thirdcheck != 3" >以截止昨日用户<span>{{checkname}}</span>的时间天数进行排名，前10名上榜</p>
      <p class="first" v-if="thirdcheck == 3" > 以实时用户抽中的所有奖品价值总和进行排名，前10名上榜</p>
      <div class="threecheck" ref="spancheck">
        <span  @click="change(1)">连续签到</span>
        <span  @click="change(2)">累计签到</span>
        <span  @click="change(3)">奖品价值</span>
      </div>
    </div>
    <div class="bottom">
      <p><span>排名</span><span>用户</span><span v-if="check!=3">签到天数</span></p>
      <p v-for="(i,item) in dataarr" :key="item"><span>{{item+4}}</span><span>{{i.nickname}}</span><span v-if="check!=3">签到天数</span></p>
    </div>
  </div>
</template>

<script>
// 荣誉榜单
export default {
  name: 'List',
  created(){
    this.Global.getShareConfig({
      title: '每日签到福利',
      desc: '签到抽豪礼，不要错过咯~'
    },this)
  },
  data(){
    return{
      dataarr:[],//
      datathree:[],//前三
      check:1,
      alldata:[],
      checkInId:'',
      checkname:'连续签到',
      thirdcheck:1
    }
  },
  methods:{
    change(flag){
      this.check = flag;
      var nowdata = JSON.parse(JSON.stringify(this.alldata))
      if(flag == 1){
        this.$refs.spancheck.children[flag-1].style.backgroundColor = '#fff'
        this.$refs.spancheck.children[flag-1].style.color = '#343434'
        this.$refs.spancheck.children[flag].style.backgroundColor = '#F4F4F4'
        this.$refs.spancheck.children[flag].style.color = '#9C9C9C'
        this.$refs.spancheck.children[flag+1].style.backgroundColor = '#E5E5E5'
        this.$refs.spancheck.children[flag+1].style.color = '#9C9C9C'
        if(nowdata.continueDays.length>3){
          this.datathree = nowdata.continueDays.splice(0,3)
          this.dataarr = nowdata.continueDays;//连续
        }else{
          this.datathree = nowdata.continueDays;
          this.dataarr = []
        }
        this.checkname = '连续签到'
        this.thirdcheck = 1
      }else if(flag == 2){       
        this.$refs.spancheck.children[flag-1].style.backgroundColor = '#fff'
        this.$refs.spancheck.children[flag-1].style.color = '#343434'
        this.$refs.spancheck.children[flag-2].style.backgroundColor = '#F4F4F4'
        this.$refs.spancheck.children[flag-2].style.color = '#9C9C9C'
        this.$refs.spancheck.children[flag].style.backgroundColor = '#E5E5E5'
        this.$refs.spancheck.children[flag].style.color = '#9C9C9C'
        if(nowdata.totalDays.length>3){
          this.datathree =nowdata.totalDays.splice(0,3)
          this.dataarr = nowdata.totalDays;//连续
        }else{
          this.datathree =nowdata.totalDays;
          this.dataarr = []
        }
        this.checkname = '累计签到'
        this.thirdcheck = 2
      }else if(flag == 3){
        this.$refs.spancheck.children[flag-1].style.backgroundColor = '#fff'
        this.$refs.spancheck.children[flag-1].style.color = '#343434'
        this.$refs.spancheck.children[flag-2].style.backgroundColor = '#F4F4F4'
        this.$refs.spancheck.children[flag-2].style.color = '#9C9C9C'
        this.$refs.spancheck.children[flag-3].style.backgroundColor = '#E5E5E5'
        this.$refs.spancheck.children[flag-3].style.color = '#9C9C9C'
        if(nowdata.wealthTops.length>3){
          this.datathree = nowdata.wealthTops.splice(0,3)
          this.dataarr = nowdata.wealthTops;//连续
        }else{
          this.datathree = nowdata.wealthTops;
          this.dataarr = []
        }
        this.checkname = '奖品价值'
        this.thirdcheck = 3
      }
    },
    getData(){
      this.axios({
        method: "POST",
        url: `checkin/honor-list`,
        data:{
          checkInId:this.checkInId
        },
        headers: {
          Authorization: `Bearer ${this.Global.getCookie("token")}`
        }
      }).then(res => {
        this.alldata = res.data.data;
        this.$refs.spancheck.children[0].style.backgroundColor = '#fff'
        this.$refs.spancheck.children[0].style.color = '#343434'
        this.$refs.spancheck.children[1].style.backgroundColor = '#F4F4F4'
        this.$refs.spancheck.children[1].style.color = '#9C9C9C'
        this.$refs.spancheck.children[2].style.backgroundColor = '#E5E5E5'
        this.$refs.spancheck.children[2].style.color = '#9C9C9C'
        if(res.data.data.continueDays.length>3){
          this.datathree =res.data.data.continueDays.splice(0,3)
          this.dataarr = res.data.data.continueDays;//连续
        }else{
          this.datathree =res.data.data.continueDays
          this.dataarr = []
        }
      })
    }
  },
  mounted(){
    this.checkInId = this.$route.query.checkInId;
    this.getData();
  }
}
</script>

<style scoped>
.thiedcheck{
  opacity: 0;
}
#List .bottom>p{
  display: flex;
  align-items: center;
  height: 2.3rem;
  border-bottom: 1px solid #E9E9E9;
  font-size: 0.75rem;
}
#List .bottom>p:nth-child(1)>span{
  color: #FF9437;
}
#List .bottom>p>span{
  text-align: center;
  color: #343434;
}
#List .bottom>p>span:nth-child(1){
  width: 33%;
}
#List .bottom>p>span:nth-child(2){
  flex: 1;
}
#List .bottom>p>span:nth-child(3){
  width: 33%;
}
#List .bottom{
  padding-bottom: 2.5rem;
  margin:  0 1rem;
  background: #fff;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
}
#List .top .threecheck>span{
  flex: 1;
  text-align: center;
  line-height: 2.5rem;
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
  font-size: 0.88rem;
  font-weight: bold;
  background: #fff;
  color: #343434;
}
#List .top .threecheck{
  margin: 0.75rem 1rem 0;
  height: 2.5rem;
  display: flex;
  align-items: center;
}
#List{
  background: #F9F9F9;
  position: absolute;
  height: 100vh;
  width: 100%;
  overflow: auto;
}

#List .top .first{
  text-align: center;
  font-size: 0.75rem;
  font-family: PingFang HK;
  color: white;
  text-shadow: 0px 1px 6px #EE6A34;
  font-weight: 600;
  padding-top: 1rem;
}

#List .top .title{
  font-size: 1.13rem;
  color: #fff;
  text-align: center;
  padding: 0.8rem 0;
}
#List .top .threeimg{
  margin: 0.5rem 2.5rem 1.03rem;
  display: flex;
  align-items: center;
}
#List .top .threeimg>div:nth-child(1){
  width: 5.44rem;
  margin-top: 5.6rem;
  
}
#List .top .threeimg>div{
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
#List .top .threeimg>div>img:nth-child(1){
  display: inline-block;
  border-radius: 50%;
}
#List .top .threeimg>div:nth-child(1)>img:nth-child(1){
  width: 3.66rem;
  height: 3.66rem;
}
#List .top .threeimg>div>img:nth-child(2){
  position: absolute;
}
#List .top .threeimg>div:nth-child(2){
  width: 6.72rem;
  margin-bottom: 4.06rem;
}
#List .top .threeimg>div:nth-child(2)>img:nth-child(1){
  width: 4.6rem;
  height: 4.4rem;
}
#List .top .threeimg>div:nth-child(3){
  width: 5.47rem;
  margin-top: 5.7rem;
}
#List .top .threeimg>div:nth-child(3)>img:nth-child(1){
  width: 3.5rem;
  height: 3.5rem;
}


#List  .top{
  background: url(../assets/images/activity/bj1.jpg) no-repeat ;
  background-size: 100% 100%;
}



</style>